import { GeocoderResult, PlaceAutocompleteResult } from './types';

export const geocode = async (placeId: string): Promise<GeocoderResult[]> => {
  if (!window.google || !window.google.maps || !window.google.maps.Geocoder) {
    console.error('Google Maps API is not loaded');
    throw new Error('Google Maps API is not loaded');
  }

  const geocoder = new google.maps.Geocoder();

  return new Promise((resolve, reject) => {
    geocoder.geocode({ placeId }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        resolve(results || []);
      } else {
        console.warn('Geocode API returned status:', status);
        reject(new Error('Geocode API returned status: ' + status));
      }
    });
  });
};

export const placeAutocomplete = async (input: string): Promise<PlaceAutocompleteResult[]> => {
  if (!window.google || !window.google.maps || !window.google.maps.places) {
    console.error('Google Places API is not loaded');
    throw new Error('Google Places API is not loaded');
  }

  const autocompleteService = new google.maps.places.AutocompleteService();

  return new Promise((resolve, reject) => {
    autocompleteService.getPlacePredictions({ input }, (predictions, status) => {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        resolve(predictions || []);
      } else {
        console.warn('Autocomplete API returned status:', status);
        reject(new Error('Autocomplete API returned status: ' + status));
      }
    });
  });
};
